import InputComponent from "V2.0/components/InputComponent";
import { Switch } from "V2.0/common/switch";

import { ConversationReminderMessageType } from "./types";

export default ConversationReminderForm;

function ConversationReminderForm(props) {
  const {
    state,
    toggleEnabled,
    updateDelayInMinutes,
    updateMessageType,
    updateStaticMessage,
    updateDynamicPrompt,
    locked,
  } = props;

  const isStaticMessage =
    state.messageType === ConversationReminderMessageType.Static;

  const isFieldsDisabled = !state.enabled || locked;

  const renderEnableToggle = (
    <div className="col-span-3 flex items-center gap-x-2">
      <p className="text-sm font-medium">Use Conversation Remidners</p>
      <Switch
        color="emerald"
        checked={state.enabled}
        onClick={toggleEnabled}
        disabled={locked}
      />
    </div>
  );

  const renderDelayInMinutes = (
    <div className="col-span-3 xl:col-span-2">
      <InputComponent
        type="number"
        name="delayInMinutes"
        label="Delay (mins)"
        description="Minimum wait time after customer’s last message."
        value={state.delayInMinutes}
        min={1}
        max={1440}
        onChange={(e) => updateDelayInMinutes(e.target.value)}
        disabled={isFieldsDisabled}
        invalid={!!state.errors.delayInMinutes}
        error={state.errors.delayInMinutes}
      />
    </div>
  );

  const renderMessageType = (
    <div className="col-span-3 xl:col-span-2">
      <InputComponent
        type="select"
        value={state.messageType}
        name="messageType"
        label="Message Type"
        onChange={(e) => updateMessageType(e.target.value)}
        options={[
          {
            id: "static",
            value: ConversationReminderMessageType.Static,
            label: "Static Predefined Message",
          },
          {
            id: "dynamic",
            value: ConversationReminderMessageType.Dynamic,
            label: "Generate Dynamic Message via Prompt",
          },
        ]}
        disabled={isFieldsDisabled}
      />
    </div>
  );

  const renderStaticMessage = (
    <div className="col-span-3">
      <InputComponent
        type="textArea"
        value={state.staticMessage}
        name="staticMessage"
        label="Message *"
        onChange={(e) => updateStaticMessage(e.target.value)}
        style={{ fontSize: "13px", height: "150px" }}
        disabled={isFieldsDisabled}
      />
      {state.errors.staticMessage && (
        <p className="text-base/6 text-red-600 data-[disabled]:opacity-50 sm:text-sm/6 dark:text-red-500">
          {state.errors.staticMessage}
        </p>
      )}
    </div>
  );

  const renderDynamicPrompt = (
    <div className="col-span-3 relative">
      <InputComponent
        type="textArea"
        value={state.dynamicPrompt}
        name="dynamicPrompt"
        label="Prompt *"
        description="Define Instructions to generate the reminder message"
        onChange={(e) => updateDynamicPrompt(e.target.value)}
        style={{ fontSize: "13px", height: "150px" }}
        disabled={isFieldsDisabled}
      />
      {state.errors.dynamicPrompt && (
        <p className="text-base/6 text-red-600 data-[disabled]:opacity-50 sm:text-sm/6 dark:text-red-500">
          {state.errors.dynamicPrompt}
        </p>
      )}
    </div>
  );

  return (
    <div className="grid grid-cols-3 px-6 space-y-4 py-4">
      {renderEnableToggle}
      <div className="col-span-3 grid grid-cols-3 space-y-6 ml-4">
        {renderDelayInMinutes}
        {renderMessageType}
        {isStaticMessage ? renderStaticMessage : renderDynamicPrompt}
      </div>
    </div>
  );
}
